/**
 * AccountDrawer — DEPRECATED Builder block.
 * Just renders children passthrough. Use href="#login" or href="#register" instead.
 */
import type React from "react";

import type { RegisteredComponent } from "@builder.io/sdk-react";

const AccountDrawer: React.FC<{
  children?: React.ReactNode;
  attributes?: Record<string, unknown>;
}> = ({ children, attributes }) => {
  return children ? <div {...attributes}>{children}</div> : null;
};

export const AccountDrawerDefinition = {
  component: AccountDrawer,
  name: "AccountDrawer",
  hideFromInsertMenu: true,
  noWrap: true,
  canHaveChildren: true,
  inputs: [
    {
      name: "startWith",
      type: "string",
      enum: ["login", "registration"],
      defaultValue: "login",
    },
  ],
} as RegisteredComponent;
